import React from "react";
import logoWhite from "../../assets/images/minutezilla-logo-white.png";

export default function Logo() {
  return (
    <img
      src={logoWhite}
      alt="Minutezilla"
      style={{ height: "40px", width: "auto" }}
    />
  );
}
